<template>
  <!-- Tip Details -->
  <div class="flex-1 blue-gradient rounded-2xl p-4 mt-4 text-left space-y-4" v-if="game">
    <h2 class="font-bold text-2xl text-white">
      {{ game?.marketName }}
    </h2>
    <div class="flex w-full justify-between">
      <h3 class="font-light text-xl text-white">Handicap</h3>
      <h3 class="font-bold text-2xl text-white">{{ game?.handicap }}</h3>
    </div>
    <div class="flex w-full justify-between">
      <h3 class="font-light text-xl text-white">Odd</h3>
      <h3 class="font-bold text-2xl text-white">{{ game?.oddValue }}</h3>
    </div>
    <div
      v-if="game.virtualTipAmount"
      class="w-full border-t border-bs-gray-light-200 my-4"
    />
    <div v-if="game.virtualTipAmount" class="flex w-full justify-between">
      <h3 class="font-light text-xl text-white">Suggested<br />Stake</h3>
      <h3 class="font-bold text-2xl text-white">
        {{ currency }} {{ game?.virtualTipAmount }}
      </h3>
    </div>
    <a
      v-if="game.statusClass === 'is-pending'"
      target="blank"
      title="Open in Bet365"
      rel="noreferrer"
      :href="getUrl()"
      class="block text-white px-4 py-4 mt-4 w-full text-center text-xl cursor-pointer transition-colors duration-300 shadow-xl rounded-xl bg-gradient-to-br from-bs-green to-green-500"
      >Open Tip </a
    >
  </div>
</template>

<script>
export default {
  props: ["game"],
  methods: {
    getUrl: function () {
      let m = Math.round(Math.random()) + 1;
      let length = Math.round(Math.random() * 6) + 6;
      switch (m) {
        case 1:
          return `https://www.bet365.com/#/AX/K^${this.game.homeTeam.substr(0, length)}`;
        case 2:
          return `https://www.bet365.com/#/AX/K^${this.game.awayTeam.substr(0, length)}`;
        default:
          return `https://www.bet365.com`;
      }
    },
  },
};
</script>

<style></style>
